const toCamel = (s: string) => {
  return s.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}

const isObject = (o: any) => {
  return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

const isArray = (a: any) => {
  return Array.isArray(a)
}

export const keysToCamel = (o: any): any => {
  if (isObject(o)) {
    const n: { [key: string]: any } = {}

    Object.keys((o as Object))
      .forEach((k) => {
        n[toCamel(k)] = keysToCamel(o[k])
      })

    return n
  } else if (isArray(o)) {
    return (o as Array<any>).map((v) => {
      return keysToCamel(v)
    })
  }

  return o
}

// TODO convert to use localized moment?
export const splitTimestamp = (timestamp: string): {date: string, time: string} => {
  let splitTimestamp = timestamp.split(' ')

  return {
    date: splitTimestamp[0],
    time: splitTimestamp[1].substr(0, 5)
  }
}
